<template>
    <div class="recharge">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' : 'content'">
            <div class="tabs" v-if="isMobile">
                <div :class="active == 1 ? 'active' : ''" @click="active = 1">{{ $t('规则') }}</div>
                <div :class="active == 2 ? 'active' : ''" @click="active = 2">{{ $t('收入记录') }}</div>
            </div>
            <div class="box" v-if="isMobile">
                <div class="box-left" v-if="active == 1">
                    <p class="title">{{ $t('质押收益规则') }}</p>
                    <img src="../../assets/img/zhiya.jpg" />
                </div>
                <div class="box-right" v-if="active == 2">
                    <p class="title">{{ $t('质押收益') }}</p>
                    <div class="box-card">
                        <div class="card">
                            <div class="left">
                                <p>{{ $t('本金合计') }}</p>
                                <span>USD 0.00</span>
                            </div>
                        </div>
                        <div class="card">
                            <div class="left">
                                <p>{{ $t('今天的矿业利润') }}</p>
                                <span>USD 0.00</span>
                            </div>
                        </div>
                    </div>
                    <p style="margin-bottom: 20px;color: #3e60cf;font-size: 18px;">{{ $t('收入记录') }}</p>
                    <div class="list-item" v-if="false">
                        <div class="list-top" v-if="!isMobile">
                            <span>839041726673956</span>
                            <p>{{ $t('订单号') }}</p>
                        </div>
                        <div class="success" v-if="!isMobile">{{ $t('成功') }}</div>
                    </div>
                    <div class="empty" v-else>
                        <img src="../../assets/img/empty.png" />
                    </div>
                </div>
            </div>
            <div class="box" v-else>
                <div class="box-left">
                    <p class="title">{{ $t('质押收益规则') }}</p>
                    <img src="../../assets/img/zhiya.jpg" />
                </div>
                <div class="box-right">
                    <p class="title">{{ $t('质押收益') }}</p>
                    <div class="box-card">
                        <div class="card">
                            <div class="left">
                                <p>{{ $t('今天的收益') }}</p>
                                <span>USD 0.00</span>
                            </div>
                        </div>
                        <div class="card">
                            <div class="left">
                                <p>{{ $t('总收入') }}</p>
                                <span>USD 0.00</span>
                            </div>
                        </div>
                    </div>
                    <p style="margin-bottom: 20px;color: #3e60cf;font-size: 18px;">{{ $t('收入记录') }}</p>
                    <div class="list-item" v-if="false">
                        <div class="list-top" v-if="!isMobile">
                            <span>839041726673956</span>
                            <p>{{ $t('订单号') }}</p>
                        </div>
                        <div class="success" v-if="!isMobile">{{ $t('成功') }}</div>
                    </div>
                    <div class="empty" v-else>
                        <img src="../../assets/img/empty.png" />
                    </div>
                </div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
    export default {
        data() {
            return {
                active: 1
            }
        },
        computed: {
            ...mapGetters("device", ["isMobile"]),
        },
        created() {

        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    .recharge {
        background-color: #fff;

        .content {
            background: #f8f8f8;
            background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
            background-position: 0;
            background-size: cover;
            display: flex;
            justify-content: center;
            min-height: 100vh;
            width: 100%;

            .box {
                width: 72%;
                margin: 20px auto 60px auto;
                display: flex;
                padding-top: 40px;

                .box-left {
                    flex: 1;

                    .title {
                        font-size: 36px;
                        color: #fff;
                        font-weight: 800;
                    }

                    img {
                        width: 520px;
                    }
                }

                .box-right {
                    flex: 1;
                    background-color: #fff;
                    border-radius: 9px;
                    padding: 30px;
                    overflow-y: scroll;
                    scrollbar-width: none;

                    .title {
                        font-size: 22px;
                        color: #1e4de7;
                    }

                    ::-webkit-scrollbar {
                        display: none;
                    }

                    .box-card {
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 14px;
                        color: #fff;

                        .card {
                            width: 30%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            background-color: #1e4de7;
                            border-radius: 12px;
                            text-align: center;
                            padding-bottom: 10px;
                            margin-bottom: 20px;
                            margin-right: 15px;
                            
                            p {
                                margin: 10px 0;
                                font-size: 13px;
                                font-weight: 600;
                            }
                        }
                    }

                    .list-item {
                        border-radius: 8px;
                        box-shadow: 0 2px 8px 0 rgba(99, 99, 99, .2);
                        box-sizing: border-box;
                        margin-bottom: 20px;
                        min-height: 100px;
                        padding: 3%;
                        width: 100%;

                        .list-top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            color: #000;
                        }

                        .success {
                            text-align: center;
                            color: #fff;
                            background-color: #1e4de7;
                            float: right;
                            padding: 5px 20px;
                            font-size: 14px;
                        }
                        &::after {
                            content: "";
                            display: table;
                            clear: both;
                        }
                    }
                }
            }
           
        }

        .m-content {

            .tabs {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-top: 40px;

                div {
                    width: 50%;
                    text-align: center;
                    pad: 14px 0;
                    color: #999;
                }

                .active {
                    width: 50%;
                    text-align: center;
                    pad: 14px 0;
                    color: #1e4de7;
                }
            }

            .box {
                width: 100%;
                display: flex;
                /* padding-top: 20px; */

                .box-left {
                    padding: 20px;

                    .title {
                        font-size: 16px;
                        color: #1e4de7;
                    }

                    img {
                        width: 100%;
                    }
                }


                .box-right {
                    background-color: #fff;
                    border-radius: 9px;
                    padding: 10px;

                    .title {
                        font-size: 16px;
                        color: #1e4de7;
                    }

                    .box-card {
                        display: flex;
                        justify-content: space-between;
                        font-size: 14px;
                        color: #fff;
                        border-radius: 12px;

                        .card {
                            width: 42%;
                            display: flex;
                            flex-direction: column;
                            background-color: #1e4de7;
                            border-radius: 12px;
                            margin-bottom: 20px;
                            padding: 10px;
                            
                            p {
                                margin: 10px 0;
                                font-size: 13px;
                                font-weight: 600;
                            }
                        }
                    }
                    
                    .btn {
                        margin: 20px 0;
                    }

                    .empty {
                        width: 100%;
                        img {
                            width: 100%;
                        }
                    }

                    .list-item {
                        border-radius: 8px;
                        box-shadow: 0 2px 8px 0 rgba(99, 99, 99, .2);
                        box-sizing: border-box;
                        padding: 10px;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;

                        .list-top {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            color: #000;

                            p {
                                font-size: 12px;
                                color: #333;
                            }

                            span {
                                font-size: 16px;
                                font-weight: 600;
                            }
                        }

                        .success {
                            text-align: center;
                            color: #fff;
                            background-color: #1e4de7;
                            float: right;
                            margin-top: 20px;
                            padding: 5px 20px;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>